<template>
  <div class="telegram-page">
    <TelegramHeader :tokens="userTokens" :full_name="full_name" />

    <div class="background">
      <div class="overlay">
        <div class="welcome-card">
          <h1>Welcome to Mudra</h1>
          <p>Earn tokens by writing. Let your creativity shine!</p>
        </div>
      </div>
    </div>

    <TelegramBottomNav />
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { supabase } from '@/supabase';
import TelegramHeader from '@/components/TelegramHeader.vue';
import TelegramBottomNav from '@/components/TelegramBottomNav.vue';

const userTokens = ref(null);
const full_name = ref('');

const loadUserData = async () => {
  // 1️⃣ Get current auth user
  const { data: { user } } = await supabase.auth.getUser();

  if (!user) {
    console.log('No user logged in!');
    return;
  }

  console.log('User:', user);

  // 2️⃣ Query your user table for profile
  let { data, error } = await supabase
    .from('user')
    .select('full_name, token_balance')
    .eq('id', user.id)
    .single();

  if (error) {
    console.error('Error fetching user data:', error);
    return;
  }

  console.log('User data:', data);
  full_name.value = data.full_name;
  userTokens.value = data.token_balance;
};

onMounted(async () => {
  await loadUserData();
});
</script>

<style scoped>
/* same as before, no changes needed */
.telegram-page {
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.background {
  flex: 1;
  position: relative;
  background: url('@/assets/mudra-bg.png') center center/cover no-repeat;
  display: flex;
  justify-content: center;
  align-items: center;
}

.overlay {
  position: absolute;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
}

.welcome-card {
  background: rgba(0, 0, 0, 0.6);
  padding: 40px 20px;
  border-radius: 12px;
  color: #fff;
  max-width: 90%;
  text-align: center;
  backdrop-filter: blur(6px);
}

.welcome-card h1 {
  margin-bottom: 16px;
  font-size: 28px;
  color: #FFD700;
}

.welcome-card p {
  font-size: 16px;
  line-height: 1.5;
}
</style>